import React, { useState, useEffect, useRef } from 'react';
import { instanceOf, func, bool } from 'prop-types';
import LinesEllipsis from 'react-lines-ellipsis'
import ContextMenu from './ContextMenu';

const DELabelEditableField = ({
  row,
  saveLabel,
  isEditable,
  setEditable,
  removeHover,
  setHover,
}) => {
  const [value, setValue] = useState(row.tl);
  const [isRestore, setIsRestore] = useState(false);
  const inputRef = useRef();
  useEffect(() => {
    setValue(row.tl);
    setIsRestore(false);
  }, [row]);

  useEffect(() => {
    if (isEditable) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [isEditable]);

  const handleChange = updatedLabel => {
    setValue(updatedLabel);
  };

  const _saveLabel = updatedLabel => {
    if (updatedLabel.trim() !== row.tl) {
      const rowData = {
        ...row,
        tl: updatedLabel.trim(),
      };
      saveLabel(rowData);
    } else {
      setValue(row.tl);
    }
    setEditable(false);
  };

  const handleDoubleClick = event => {
    event.stopPropagation();
    setEditable(true);
  };

  const _handleAction = (row, action) => {
    switch (action) {
      case 'editLabel':
        setEditable(true);
        break;
      case 'clearLabel':
        _saveLabel('');
        break;
      case 'restoreLabel':
        _saveLabel(row.sl);
        setIsRestore(true);
        break;
      default:
    }
  };

  const renderEllipsisInput = () => {
    if (isRestore) {
      return (
        <div className="de--label--element--label--text">{row.tl}</div>
      )
    }
    return (
      <div
        className="de--label--element--label--text"
        onDoubleClick={e => handleDoubleClick(e)}
      >
        <LinesEllipsis
          text={value}
          maxLine={(row.ty === 'keyword' || row.ty === 'misc') ? "2" : "1"}
          ellipsis='...'
          trimRight
          basedOn='letters'
        />
      </div>
    )
  }

  const _renderInput = () => {
    if (row.ty === 'keyword' || row.ty === 'misc') {
      return (
        <textarea
          id={row.id}
          ref={inputRef}
          value={value}
          onChange={e => handleChange(e.target.value)}
          className="de--label--row__editable-textarea"
          onBlur={() => _saveLabel(value)}
        />
      );
    }
    return (
      <input
        id={row.id}
        ref={inputRef}
        type="text"
        value={value}
        onChange={e => handleChange(e.target.value)}
        className="de--label--row__editable-input"
        onBlur={() => _saveLabel(value)}
        autoComplete="off"
      />
    );
  };
  return (
    <div
      className="de--label--element"
    >
      <div className="de--label--element--label">
        {isEditable ? (
          <div className="de--label--element--input">{_renderInput()}</div>
        ) : renderEllipsisInput()}
      </div>
      <div className="de--label--element--actions">
        <ContextMenu
          data-test="labelcontextmenu"
          row={row}
          onClick={_handleAction}
          removeHover={removeHover}
          setHover={setHover}
        />
      </div>
    </div>
  );
};

DELabelEditableField.propTypes = {
  row: instanceOf(Object),
  saveLabel: func,
  isEditable: bool,
  setEditable: func,
  removeHover: func,
  setHover: func,
};

export default DELabelEditableField;
